import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  getFilteredTaskListsByProjectSelector,
  makeFilteredTaskListIdsByProjectSelector,
} from "~/store/selectors/selector.taskLists";
import { getTaskById, makeFilteredOpenTaskIdsByTaskListSelector } from "~/store/selectors/selector.tasks";

export const useListColumnNavigation = (taskId) => {
  const selectorFilteredOpenTasks = useMemo(makeFilteredOpenTaskIdsByTaskListSelector, []);
  const selectorFilteredTaskListsByProject = useMemo(makeFilteredTaskListIdsByProjectSelector, []);

  let task = useSelector((state) => getTaskById(state, taskId));

  if (task && (task.get("is_completed") || task.get("is_trashed"))) {
    task = undefined;
  }
  let previous, next;

  const taskListId = task?.get("task_list_id");
  const projectId = task?.get("project_id");

  const tasksByListIds = useSelector((state) => selectorFilteredOpenTasks(state, taskListId));

  const taskListIds = useSelector((state) => selectorFilteredTaskListsByProject(state, projectId));

  const filteredTaskListsByProject = useSelector((state) => getFilteredTaskListsByProjectSelector(state, projectId));
  const currentIndex = tasksByListIds.indexOf(taskId);
  const currentListIndex = taskListIds.indexOf(taskListId);

  previous = currentIndex > -1 && tasksByListIds[currentIndex - 1] ? tasksByListIds[currentIndex - 1] : null;
  next = currentIndex > -1 && tasksByListIds[currentIndex + 1] ? tasksByListIds[currentIndex + 1] : null;

  const prevList = useMemo(() => {
    if (currentListIndex === -1) {
      return undefined;
    }
    let index = currentListIndex;
    const lists = filteredTaskListsByProject ? filteredTaskListsByProject.toList().toArray() : [];
    let _prevList = lists[index - 1];
    while (_prevList && _prevList.get("open_tasks", 0) === 0) {
      const newIndex = index - 1;
      _prevList = lists[newIndex];
      index = newIndex;
    }
    return _prevList;
  }, [currentListIndex, filteredTaskListsByProject]);

  const nextList = useMemo(() => {
    if (currentListIndex === -1) {
      return undefined;
    }
    let index = currentListIndex;

    const lists = filteredTaskListsByProject ? filteredTaskListsByProject.toList().toArray() : [];
    let _nextList = lists[index + 1];
    while (_nextList && _nextList.get("open_tasks", 0) === 0) {
      const newIndex = index + 1;
      _nextList = lists[newIndex];
      index = newIndex;
    }
    return _nextList;
  }, [currentListIndex, filteredTaskListsByProject]);

  const nextOpenTasks = useSelector((state) => selectorFilteredOpenTasks(state, nextList?.id));

  const prevOpenTasks = useSelector((state) => selectorFilteredOpenTasks(state, prevList?.id));

  if (!next && nextOpenTasks && nextOpenTasks.length > 0) {
    next = nextOpenTasks[0]; //first in next list
  }

  if (!previous && prevOpenTasks && prevOpenTasks.length > 0) {
    previous = prevOpenTasks[prevOpenTasks.length - 1]; //last in previous list
  }

  if (currentIndex === -1) {
    return [null, null];
  }

  return [previous, next];
};
